module.exports = __webpack_public_path__ + "static/media/MATH3620.81cba9d9.pdf";